import { createAsyncThunk } from '@reduxjs/toolkit';

import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';

import {
    AddCatalogItemRequestBody,
    AddCatalogItemResponse,
} from '../types/AddCatalogItemSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const addCatalogItemService = createAsyncThunk<
    AddCatalogItemResponse,
    AddCatalogItemRequestBody,
    ThunkConfig<any>
>('catalogItem/addToCatalog', async ({ data, catalogId }, thunkApi) => {
    const { extra, rejectWithValue, dispatch } = thunkApi;

    try {
        const response = await extra.api.post<AddCatalogItemResponse>(
            `/v1/catalogs/${catalogId}/items`,
            data,
        );

        dispatch(catalogItemActions.removeAllSelection());

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
